<template>
  <div class="container">
    <div class="main">
      <div class="area">
        <span style="font-weight: bold; color: #333">地理位置：</span>
        <span
          v-for="(item, index) in areaList"
          :key="index"
          class="area_item"
          :class="item.active ? 'active' : ''"
          @click="changeArea(index, item.area_id)"
        >
          {{ item.area_name }}
        </span>
      </div>
      <div class="house_content" :class="{ 'with-building': showBuildingList }">
        <div class="house_left" ref="houseLeft">
          <div class="card_list" :class="{ 'two-column': showBuildingList }">
            <div
              class="card_list_item"
              v-for="(item, index) in houseList"
              :key="index"
              @click="showDetail(item.fx_id || item.house_id)"
            >
              <div class="img_out">
                <img v-lazy="item.cover_picture?.path" />
              </div>
              <div class="card_footer">
                <span class="title">{{ item.fx_name }}</span>
                <div class="room_info">
                  <div class="room_info_l">
                    <span>{{ item.acreage_min }}-{{ item.acreage_max }}㎡</span>
                    <span>|</span>
                    <span>{{ item.rental_type == 1 ? "整租" : "合租" }}</span>
                  </div>
                  <div class="room_info_r">
                    <span class="price"
                      >{{ Number(item.price_min).toFixed(0) }}-{{
                        Number(item.price_max).toFixed(0)
                      }}</span
                    >
                    <span class="unit">元/月</span>
                  </div>
                </div>
                <div class="tag">
                  <div
                    class="tag_item"
                    v-for="(item2, index2) in item.appliances"
                    :key="index2"
                  >
                    {{ item2.bq_name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 分页组件 -->
          <paginate
            :page-count="total"
            :click-handler="changPage"
            :prev-text="'上一页'"
            :next-text="'下一页'"
            :container-class="'className'"
            :page-class="'page-item'"
          >
          </paginate>
        </div>
        <div
          v-if="showBuildingList"
          class="building_panel"
          :style="{ height: buildingPanelHeight + 'px' }"
          ref="buildingPanel"
          @scroll="handleBuildingScroll"
        >
          <div class="building_title">楼栋列表</div>
          <div
            class="building_item"
            v-for="(item, index) in visibleBuildingList"
            :key="item.buildingKey || index"
            @click="handleShowBuild(item)"
          >
            <div class="building_img">
              <img v-lazy="item.cover" />
            </div>
            <div class="building_info">
              <div class="building_name">{{ item.name }}</div>
              <div class="building_address">{{ item.address }}</div>
              <div class="building_tags" v-if="item.tags && item.tags.length">
                <div class="building_tag" v-for="tag in item.tags" :key="tag">
                  {{ tag }}
                </div>
              </div>
              <div class="building_price">
                <template v-if="item.hasPrice">
                  <span>{{ item.price }}</span>
                  <em>元</em>
                  <i>/月</i>
                </template>
                <span v-else class="no_price">暂无</span>
              </div>
            </div>
          </div>
          <div class="building_status" v-if="buildingLoading">加载中...</div>
          <div class="building_status" v-else-if="!buildingHasMore">
            没有更多了
          </div>
        </div>
        <button
          class="building_toggle"
          :class="{ open: showBuildingList }"
          @click="toggleBuildingList"
        >
          <img
            v-if="!showBuildingList"
            src="@/assets/image/loudong.png"
            alt="楼栋列表"
          />
        </button>
      </div>
    </div>
    <room-detail ref="roomDetail" :isShow="isShow" />
    <build-detail v-if="showBuildDetail" :itemData="itemData" />
    <loading v-if="isLoading" />
  </div>
</template>
<script>
import roomDetail from "@/components/roomDetail";
import buildDetail from "@/components/buildDetail";
import { getArea, getHouse, getBuildingLists } from "@/api/lookHouse";
import paginate from "vuejs-paginate";
export default {
  name: "lookHouse",
  components: {
    roomDetail,
    buildDetail,
    paginate,
  },
  data() {
    return {
      query: {
        page: 1,
        per_page: 9,
        area_id: null,
      },
      total: 0,
      areaList: [],
      houseList: [],
      isShow: false,
      isLoading: false,
      showBuildingList: false,
      buildingQuery: {
        page: 1,
        per_page: 9,
        area_id: null,
      },
      buildingLoading: false,
      buildingHasMore: true,
      visibleBuildingList: [],
      loadedBuildingKeys: [],
      buildingRequestToken: 0,
      buildingPanelHeight: 912,
      houseLeftResizeObserver: null,
      resizeTimer: null,
      heightUpdateFrame: null,
      showBuildDetail: false,
      itemData: true,
    };
  },
  mounted() {
    this.initData();
    window.addEventListener("resize", this.handleWindowResize);
    this.$nextTick(() => {
      this.observeHouseLeftHeight();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
    if (this.houseLeftResizeObserver) {
      this.houseLeftResizeObserver.disconnect();
      this.houseLeftResizeObserver = null;
    }
    if (this.resizeTimer) {
      window.clearTimeout(this.resizeTimer);
      this.resizeTimer = null;
    }
    if (this.heightUpdateFrame) {
      window.cancelAnimationFrame(this.heightUpdateFrame);
      this.heightUpdateFrame = null;
    }
  },
  methods: {
    initData() {
      this.isLoading = true;
      const area = getArea();
      const house = getHouse(this.query);
      Promise.all([area, house])
        .then((res) => {
          //处理地区
          res[0].data.forEach((item) => {
            item.active = false;
          });
          this.areaList = res[0].data;
          //处理房源
          this.houseList = res[1].data;
          this.total = Math.ceil(res[1].total / this.query.per_page);
          this.scheduleBuildingPanelHeightUpdate();
        })
        .finally((_) => {
          this.isLoading = false;
        });
    },
    async initHouse() {
      const res = await getHouse(this.query);
      this.houseList = res.data;
      this.total = Math.ceil(res.total / this.query.per_page);
      this.scheduleBuildingPanelHeightUpdate();
    },
    changeArea(i, id) {
      this.areaList.forEach((item, index) => {
        if (i == index) {
          item.active = true;
        } else {
          item.active = false;
        }
      });
      this.query.area_id = id;
      this.query.page = 1;
      this.buildingQuery.area_id = id;
      this.resetBuildingList();
      this.initHouse();
      if (this.showBuildingList) {
        this.loadBuildingPage();
      }
    },
    showDetail(id) {
      this.isShow = true;
      this.$refs.roomDetail.detailId = id;
      this.$refs.roomDetail.translateX = 0;
      this.$refs.roomDetail.current = 0;
      this.$refs.roomDetail.initPageData();
    },
    //分页
    changPage(pageNum) {
      this.query.page = pageNum;
      this.initHouse();
    },
    toggleBuildingList() {
      this.showBuildingList = !this.showBuildingList;
      if (this.showBuildingList) {
        this.$nextTick(() => {
          this.scheduleBuildingPanelHeightUpdate();
          if (this.$refs.buildingPanel) {
            this.$refs.buildingPanel.scrollTop = 0;
          }
          if (!this.visibleBuildingList.length) {
            this.loadBuildingPage();
          }
          this.fillBuildingPanel();
        });
      }
    },
    resetBuildingList() {
      this.buildingRequestToken += 1;
      this.buildingQuery.page = 1;
      this.visibleBuildingList = [];
      this.loadedBuildingKeys = [];
      this.buildingHasMore = true;
      this.buildingLoading = false;
    },
    async loadBuildingPage() {
      if (this.buildingLoading || !this.buildingHasMore) return;
      this.buildingLoading = true;
      const requestToken = this.buildingRequestToken;
      const requestPage = this.buildingQuery.page;
      try {
        const res = await getBuildingLists({
          ...this.buildingQuery,
          page: requestPage,
        });
        if (requestToken !== this.buildingRequestToken) return;
        const list = this.getResponseList(res).map(this.formatBuildingItem);
        const total = Number(
          res.total || res.count || (res.data && res.data.total) || 0
        );
        const nextList = list.filter((item) => {
          if (!item.buildingKey || this.loadedBuildingKeys.includes(item.buildingKey)) {
            return false;
          }
          this.loadedBuildingKeys.push(item.buildingKey);
          return true;
        });
        this.visibleBuildingList = this.visibleBuildingList.concat(nextList);
        this.buildingQuery.page = requestPage + 1;
        this.buildingHasMore = total
          ? this.visibleBuildingList.length < total
          : list.length >= this.buildingQuery.per_page;
        if (!nextList.length && list.length < this.buildingQuery.per_page) {
          this.buildingHasMore = false;
        }
      } finally {
        this.buildingLoading = false;
        this.$nextTick(() => {
          this.fillBuildingPanel();
        });
      }
    },
    getResponseList(res) {
      if (Array.isArray(res.data)) return res.data;
      if (res.data && Array.isArray(res.data.data)) return res.data.data;
      if (res.data && Array.isArray(res.data.list)) return res.data.list;
      if (Array.isArray(res.list)) return res.list;
      return [];
    },
    formatBuildingItem(item) {
      const fallbackCover = require("@/assets/image/error.png");
      const appliances = (item.labels || []).slice(0, 4);
      const files = item.files || [];
      const hasMinPrice =
        item.min_price !== null &&
        item.min_price !== undefined &&
        item.min_price !== "";
      const hasMaxPrice =
        item.max_price !== null &&
        item.max_price !== undefined &&
        item.max_price !== "";
      const hasPrice = hasMinPrice && hasMaxPrice;
      return {
        id: item.building_id,
        buildingKey: String(item.building_id || item.id || item.building_name),
        name: item.building_name,
        address: item.address,
        tags: appliances.map((tag) => tag.bq_name),
        hasPrice,
        price: hasPrice
          ? `${Number(item.min_price).toFixed(0)}-${Number(
              item.max_price
            ).toFixed(0)}`
          : "暂无",
        cover: files.length && files[0].path ? files[0].path : fallbackCover,
      };
    },
    handleBuildingScroll(event) {
      const target = event.target;
      const distanceToBottom =
        target.scrollHeight - target.scrollTop - target.clientHeight;
      if (distanceToBottom <= 20) {
        this.loadBuildingPage();
      }
    },
    scheduleBuildingPanelHeightUpdate() {
      if (this.heightUpdateFrame) {
        window.cancelAnimationFrame(this.heightUpdateFrame);
      }
      this.heightUpdateFrame = window.requestAnimationFrame(() => {
        this.heightUpdateFrame = null;
        this.updateBuildingPanelHeight();
      });
    },
    updateBuildingPanelHeight() {
      this.$nextTick(() => {
        if (!this.$refs.houseLeft) return;
        const nextHeight = Math.max(this.$refs.houseLeft.offsetHeight, 912);
        if (this.buildingPanelHeight !== nextHeight) {
          this.buildingPanelHeight = nextHeight;
        }
        if (this.showBuildingList) {
          this.$nextTick(() => {
            this.fillBuildingPanel();
          });
        }
      });
    },
    handleWindowResize() {
      if (this.resizeTimer) {
        window.clearTimeout(this.resizeTimer);
      }
      this.scheduleBuildingPanelHeightUpdate();
      this.resizeTimer = window.setTimeout(() => {
        this.scheduleBuildingPanelHeightUpdate();
      }, 120);
    },
    observeHouseLeftHeight() {
      if (!window.ResizeObserver || !this.$refs.houseLeft) {
        return;
      }
      this.houseLeftResizeObserver = new ResizeObserver(() => {
        this.scheduleBuildingPanelHeightUpdate();
      });
      this.houseLeftResizeObserver.observe(this.$refs.houseLeft);
    },
    fillBuildingPanel() {
      this.$nextTick(() => {
        const panel = this.$refs.buildingPanel;
        if (
          !this.showBuildingList ||
          !panel ||
          this.buildingLoading ||
          !this.buildingHasMore
        ) {
          return;
        }
        if (panel.scrollHeight <= panel.clientHeight) {
          this.loadBuildingPage();
        }
      });
    },
    handleShowBuild(item) {
      this.itemData = item;
      this.showBuildDetail = true;
    },
  },
};
</script>
<style scoped lang="scss">
$width: 1600px;
.container {
  box-sizing: border-box;
  width: 100vw;
  height: auto;
  .main {
    width: $width;
    height: auto;
    margin: 0 auto;
    padding: 0 50px;
    box-sizing: border-box;
    .area {
      width: 100%;
      height: 90px;
      display: flex;
      align-items: center;
      column-gap: 42px;
      border-bottom: 1px solid #eeeeee;
      font-size: 18px;
      &_item {
        cursor: pointer;
      }
      .active {
        color: #ffa71d;
        transition: all 0.3s ease;
      }
    }
    .house_content {
      position: relative;
      display: flex;
      align-items: flex-start;
      gap: 24px;
      margin: 30px 0;
      .house_left {
        width: 100%;
        transition: width 0.3s ease;
      }
      &.with-building {
        align-items: stretch;
        .house_left {
          width: 988px;
          flex: 0 0 988px;
        }
      }
    }
    .card_list {
      display: grid;
      grid-template-columns: repeat(3, 482px);
      gap: 24px;
      transition: all 0.3s ease;
      &.two-column {
        grid-template-columns: repeat(2, 482px);
      }
      &_item {
        width: 100%;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid #eeeeee;
        overflow: hidden;
        cursor: pointer;
        transition: all 0.3s ease;
        &:hover {
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }
        .card_footer {
          padding: 20px;
          box-sizing: border-box;
          color: #333333;
          .title {
            font-size: 22px;
            &:hover {
              color: #ffa71d;
            }
          }
          .room_info {
            display: flex;
            justify-content: space-between;
            margin: 20px 0;
            align-items: center;
            &_l {
              display: flex;
              column-gap: 15px;
              color: #666666;
              font-size: 16px;
            }
            &_r {
              .price {
                font-size: 28px;
                color: #ff9517;
                font-weight: bold;
              }
            }
          }
          .tag {
            display: flex;
            column-gap: 10px;
            flex-wrap: wrap;
            &_item {
              padding: 2px 6px;
              border: 1px solid #d9d9d9;
              border-radius: 4px;
              font-size: 14px;
              color: #666666;
            }
          }
        }
        .img_out {
          width: 100%;
          height: 341px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            border-radius: 10px 10px 0 0;
            object-fit: cover;
            transition: all 0.3s ease;
            &:hover {
              transform: scale(1.1);
            }
          }
        }
      }
    }
    .building_toggle {
      position: absolute;
      right: -90px;
      top: 0;
      z-index: 2;
      width: 68px;
      height: 68px;
      border: 0;
      border-radius: 50%;
      padding: 0;
      background: transparent;
      color: #ffffff;
      font-size: 22px;
      line-height: 1;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s ease;
      img {
        display: block;
        width: 68px;
        height: 68px;
      }
      &::after {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        width: 68px;
        height: 68px;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        pointer-events: none;
      }
      &.open {
        right: auto;
        left: 991px;
        top: 520px;
        width: 42px;
        height: 42px;
        background: #ffa71d;
        box-shadow: 0 6px 14px rgba(255, 167, 29, 0.35);
        font-size: 0;
        line-height: 42px;
        &::before {
          content: "";
          position: absolute;
          left: 50%;
          top: 50%;
          width: 13px;
          height: 13px;
          border-top: 4px solid #ffffff;
          border-right: 4px solid #ffffff;
          transform: translate(-60%, -50%) rotate(45deg);
        }
        &::after {
          display: none;
        }
      }
    }
    .building_panel {
      flex: 1;
      width: auto;
      min-width: 0;
      min-height: 912px;
      padding: 24px 22px 18px;
      box-sizing: border-box;
      border: 1px solid #eeeeee;
      border-radius: 8px;
      background: #ffffff;
      overflow-y: auto;
      scrollbar-color: #bfbfbf transparent;
      scrollbar-width: thin;
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 6px;
        background: #bfbfbf;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      .building_title {
        margin-bottom: 18px;
        font-size: 20px;
        line-height: 28px;
        font-weight: bold;
        color: #333333;
      }
      .building_item {
        display: flex;
        align-items: flex-start;
        column-gap: 18px;
        padding-bottom: 24px;
        margin-bottom: 24px;
        border-bottom: 1px solid #f2f2f2;
        cursor: pointer;
        &:last-of-type {
          border-bottom: 0;
        }
        .building_img {
          flex: 0 0 154px;
          width: 154px;
          height: 124px;
          overflow: hidden;
          border-radius: 6px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: all 0.3s ease;
            &:hover {
              transform: scale(1.1);
            }
          }
        }
        .building_info {
          flex: 1;
          min-width: 0;
          color: #666666;
          .building_name {
            margin-bottom: 6px;
            overflow: hidden;
            color: #333333;
            font-size: 18px;
            line-height: 26px;
            font-weight: 500;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .building_address {
            max-width: 100%;
            margin-bottom: 8px;
            overflow: hidden;
            color: #888888;
            font-size: 13px;
            line-height: 18px;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .building_tags {
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
            min-height: 28px;
            margin-bottom: 8px;
          }
          .building_tag {
            display: flex;
            align-items: center;
            height: 24px;
            padding: 0 8px;
            box-sizing: border-box;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            font-size: 12px;
            line-height: 22px;
            color: #666666;
            background: #ffffff;
          }
          .building_price {
            display: flex;
            align-items: baseline;
            color: #ff9517;
            span {
              font-size: 26px;
              line-height: 32px;
              font-weight: bold;
            }
            em {
              margin-left: 2px;
              font-style: normal;
              font-size: 13px;
              color: #333333;
            }
            i {
              margin-left: 2px;
              font-style: normal;
              font-size: 13px;
              color: #666666;
            }
            .no_price {
              color: #999999;
              font-size: 18px;
              line-height: 32px;
              font-weight: 500;
            }
          }
        }
      }
      .building_status {
        padding: 6px 0 4px;
        color: #999999;
        font-size: 13px;
        text-align: center;
      }
    }
  }
}
.className {
  display: flex;
  column-gap: 10px;
  justify-content: flex-end;
  padding: 20px 0;
  box-sizing: border-box;
  ::v-deep li {
    padding: 2px 8px;
    box-sizing: border-box;
    border: 1px solid #eeeeee;
    color: #666;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE 10+/Edge */
    user-select: none;
  }
  ::v-deep .page-item {
    width: 30px;
    height: 30px;
  }
  ::v-deep .active {
    background-color: #ffa71d;
    color: #fff;
  }
}
</style>
